// @flow
export { default } from './activity-feed';
